export enum ResponseCacheWebWorkerType {
    Check = 0,
    Get = 1,
    Set = 2,
    Unknown = 100
}